import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { MyApps } from './pages/MyApps';
import { Pipeline } from './pages/Pipeline';
import { PipelineDemo } from './pages/PipelineDemo';
import { AssemblyLines } from './pages/AssemblyLines';
import { AssemblyLineEditor } from './pages/AssemblyLineEditor';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { AdminUsers } from './pages/AdminUsers';
import { AdminSettings } from './pages/AdminSettings';
import { AcceptInvite } from './pages/AcceptInvite';
import { Suspended } from './pages/Suspended';
import { SuperAdminEnterprises } from './pages/SuperAdminEnterprises';
import { SuperAdminAuditLog } from './pages/SuperAdminAuditLog';
import { SandboxTest } from './pages/SandboxTest';
import { RequireAuth, RequireAdmin, RequireSuperAdmin } from './components/RequireAuth';

export default function App() {
  return (
    <Routes>
      {/* Public auth routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/accept-invite" element={<AcceptInvite />} />
      <Route path="/suspended" element={<Suspended />} />

      {/* WebContainer POC — public so it's easy to validate end-to-end. */}
      <Route path="/sandbox-test" element={<SandboxTest />} />

      {/* Authenticated app routes */}
      <Route path="/" element={<RequireAuth><Landing /></RequireAuth>} />
      <Route path="/apps" element={<RequireAuth><MyApps /></RequireAuth>} />
      <Route path="/pipeline/:projectId" element={<RequireAuth><Pipeline /></RequireAuth>} />
      <Route path="/pipeline/:projectId/demo" element={<RequireAuth><PipelineDemo /></RequireAuth>} />
      {/* AssemblyLine CRUD is platform-curation: super-admin only.
          Non-super-admins still consume assemblyLines indirectly when bootstrapping
          a project (the assemblyLine dropdown on Landing reads /api/assembly-lines which
          remains open to all authenticated users). */}
      <Route path="/assembly-lines" element={<RequireSuperAdmin><AssemblyLines /></RequireSuperAdmin>} />
      <Route path="/assembly-lines/:assemblyLineId/edit" element={<RequireSuperAdmin><AssemblyLineEditor /></RequireSuperAdmin>} />
      <Route path="/assembly-lines/new" element={<RequireSuperAdmin><AssemblyLineEditor /></RequireSuperAdmin>} />

      {/* Admin-only */}
      <Route path="/admin/users" element={<RequireAdmin><AdminUsers /></RequireAdmin>} />
      <Route path="/admin/settings" element={<RequireAdmin><AdminSettings /></RequireAdmin>} />
      {/* Workspace settings folded into the Settings → General tab. */}
      <Route path="/admin/workspace" element={<Navigate to="/admin/settings" replace />} />

      {/* Super-admin (platform operator) only */}
      <Route path="/super-admin/enterprises" element={<RequireSuperAdmin><SuperAdminEnterprises /></RequireSuperAdmin>} />
      <Route path="/super-admin/audit-log" element={<RequireSuperAdmin><SuperAdminAuditLog /></RequireSuperAdmin>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
